import { create } from "zustand";

const useCandidateStore = create((set) => ({
    isCandidateModalOpen: false,
    isCandidateUpdateModalOpen: false,
    setCandidateModalOpen: () => {
        set({ isCandidateModalOpen: true });
    },
    handleModalOk: () => {
        set({ isCandidateModalOpen: false });
    },
    handleModalCancel: () => {
        set({ isCandidateModalOpen: false });
    },
    handleResumeUpload: (value) => {
        console.log(value);
    },

    setCandidateUpdateModalOpen: () => {
        set({ isCandidateUpdateModalOpen: true });
    },
    handleUpdateModalOk: () => {
        set({ isCandidateUpdateModalOpen: false });
    },
    handleUpdateModalCancel: () => {
        set({ isCandidateUpdateModalOpen: false });
    },    
}));

export default useCandidateStore;
